import React from "react";
import CategoriesWrapper from "../../components/CategoriesWrapper/CategoriesWrapper";
export default function Homepage() {
  return (
<>
    <h1 className="text-center text-4xl bg-black py-2 mb-8 text-white">Home</h1>
    <CategoriesWrapper />;
</>
  )
}
